import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { mdi } from 'vuetify/iconsets/mdi'
import type { IconSet, IconProps } from 'vuetify'
import { h } from 'vue'
import vuetifyConfig from '~/vuetifyConfig'

const ms: IconSet = {
  component: (props: IconProps) =>
    h('span', {
      class: 'material-symbols-sharp',
      style: { 'font-variation-settings': "'FILL' 1" },
    }, props.icon as string),
}

const mso: IconSet = {
  component: (props: IconProps) =>
    h('span', { class: 'material-symbols-sharp' }, props.icon as string),
}

export default defineNuxtPlugin(nuxtApp => {
  const vuetify = createVuetify({
    components,
    directives,
    ...vuetifyConfig,
    icons: {
      defaultSet: 'mdi',
      sets: { mdi, ms, mso },
    },
  })

  nuxtApp.vueApp.use(vuetify)
})
